/** Evento che riapre il banner dei cookie sulle preferenze (piede di pagina, cookie policy) */
export const OPEN_COOKIE_PREFERENCES_EVENT = "open-cookie-preferences";

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}

/**
 * Cancella i cookie di Google Analytics (_ga, _ga_<ID>, _gid) quando l'utente rifiuta o revoca
 * le statistiche: GA li imposta sul dominio principale, quindi si prova su host e dominio.
 */
export function clearAnalyticsCookies() {
  const names = document.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((n) => n === "_gid" || n === "_ga" || n.startsWith("_ga_"));
  if (!names.length) return;
  const host = window.location.hostname;
  const parts = host.split(".");
  const domains = ["", host, parts.length > 1 ? `.${parts.slice(-2).join(".")}` : ""].filter((d, i, a) => a.indexOf(d) === i);
  for (const name of names) {
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; Path=/${domain ? `; Domain=${domain}` : ""}`;
    }
  }
}
